import React, { FC } from 'react';
import IconButtonBase from '../../base/IconButtonBase';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import View from '../View';
import { green, iconGrey, red } from '../../../constants/palette';
import styles from './styles';

// TODO: Fix this storybook. Currently we need to figure out how to load the fonts into storybook for react vector icons
export type ThumbsButtonProps = {
  isActive: boolean;
  onPress: (e: any) => void;
  likeType: string;
};

export const ThumbsButton: FC<ThumbsButtonProps> = (props) => {
  const { isActive, likeType, onPress } = props;

  const selectIcon = () => {
    let iconColor, iconName;
    if (likeType === 'up') {
      iconColor = green;
      iconName = 'thumb-up-outline';
    } else if (likeType === 'down') {
      iconColor = red;
      iconName = 'thumb-down-outline';
    }
    if (isActive) {
      return (
        <MaterialCommunityIcons name={iconName} size={30} color={iconColor} />
      );
    }
    return (
      <MaterialCommunityIcons name={iconName} size={30} color={iconGrey} />
    );
  };
  return (
    <IconButtonBase
      containerStyle={styles.container}
      hoverStyle={styles.hover}
      onPress={() => onPress(likeType)}
    >
      <View style={styles.iconBox}>{selectIcon()}</View>
    </IconButtonBase>
  );
};

export default ThumbsButton;
